export default __webpack_public_path__ + "static/media/a3.0cef064a.png";